import { Link } from "react-router-dom";

import { Card, EmptyState, Page } from "../components/primitives";

export function NotFoundScreen() {
  return (
    <Page>
      <Card>
        <EmptyState
          title="That page does not exist."
          body="The link may be out of date, or the section may have moved."
          action={
            <Link to="/" className="btn btn--ghost">
              Go to the dashboard
            </Link>
          }
        />
      </Card>
    </Page>
  );
}
